export enum SignupStatusEnum {
  CHOOSE_USERNAME = '/choose-username',
  CHOOSE_AVATAR = '/upload-image',
  SHOW_SIGNUP_SLIDES = '/welcome',
  SET_UI_MODE = '/choose-theme',
  CREATE_STRATEGY = '/strategies', // '/actual',
  ADD_ASSETS = '/strategies', // '/actual',
  CHOOSE_WORKSPACE = '/strategies', // '/actual',
  COMPLETED = '/strategies', // '/actual',
  CHOOSE_SUBSCRIPTION = '/choose-plan',
}
